// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3C6zh","info":"PatientInfo_info__1QNEv"};